module.exports = __webpack_public_path__ + "img/이동교통.546bfd42.png";